/**
 * Copyright © 2014 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 10.07.2014, 19:11
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { BasicConstants } from "../../constants/BasicConstants";
import { LiveEnvironment } from "./LiveEnvironment";

/**
 * Represents the live or production environment of the client
 */
export class UsabilityTestEnvironment extends LiveEnvironment {
    public static USABILITY_TEST_ENVIRONMENT_ID: string = "UsabilityTestEnvironment";

    constructor() {
        super(UsabilityTestEnvironment.USABILITY_TEST_ENVIRONMENT_ID);
    }

    public initPatterns(): void {
        super.initPatterns();

        if (!this._data.globals.urlVariables.forceToShowTestServers) {
            this._networkConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-netconf/{gameId}/{networkId}.xml";
        }

        this._languageConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config/language/{gameId}/{languageVersion}/{languageCode}.{zipSuffix}";
        this._cldrConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config/language/{gameId}/cldr";

        this._versionPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config/version/{gameId}/version.json";
        this._itemsVersionPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/loader/{gameTitle}/ItemsVersion.properties";

        this._refCountURLPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/loader-usability/refcount.php";
    }

    public isSupported(): boolean {
        return this._data.globals.isUsabilityTest;
    }
}
